import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { onSnapshot, doc } from "firebase/firestore";
import { db } from "../../services/Firebase";
import LoadingPage from "../../components/Loading";
import BookingSuccess from "../booking/components/Success";
import NotFound from "../extras/404";

function Ticket() {
    const params = useParams();
    const id = params.id;

    let [loading, setLoading] = useState(true);
    let [ticket, setTicket] = useState({});
    let [error, setError] = useState(null);

    useEffect(() => {
        onSnapshot(doc(db, "bookings", id), (doc) => {
            if (doc.exists()) {
                setLoading(false);
                setTicket({
                    bookingId: doc.id,
                    ...doc.data(),
                });
            } else {
                setLoading(false);
                setError({ message: "No such booking found" });
            }
        }, (error) => {
            setLoading(false);
            setError(error);
        });
    }, [id]);

    if (loading) {
        return <LoadingPage
            text={"Checking your booking"}
            caption={"Please wait while we check your booking"}
        />;
    }

    if (error) {
        return <NotFound />;
    }

    return (
        <BookingSuccess details={ticket} />
    );
}

export default Ticket;